import React, { useCallback, useEffect, useState } from 'react';

import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Spinner from 'react-bootstrap/Spinner';

const errorMessage = async (res) => {
    try {
        const data = await res.json();
        if (data && data.description) return data.description;
    } catch (e) {
        // not JSON — e.g. nginx's HTML page when a worker is killed
    }
    return 'Chat is temporarily unavailable. Please contact HealthRate support.';
};

export default function Chat({ element_id, username, handleAPIRequest, chatContext }) {

    const [alertError, setAlertError] = useState(null)

    const [chatMessage, setChatMessage] = useState('');
    const [chatHistory, setChatHistory] = useState([]);

    const [chatMessageSending, setChatMessageSending] = useState(false);

    const resetChat = useCallback(() => {

        const do_fetch = async () => {
            const res = await handleAPIRequest('/api/v1/chatbot_reset', { method: 'GET' });
            
            if (res.status === 200) {
                console.log('reset chat');    
            } 
            else { 
                const body = await errorMessage(res);
                setAlertError({ title: 'Error Resetting Chat: ', body });
                setTimeout(() => {setAlertError(null)}, 5000);
                console.error('Error resetting chat', body);
            }
        }

        do_fetch();

    }, [handleAPIRequest]);

    const setChatContext = useCallback( () => {
        
        const do_post = async () => {

            const res = await handleAPIRequest(
                '/api/v1/chatbot'
            ,   {
                method: 'POST',
                body: JSON.stringify({ 
                    chatbot_input: `Here is a little context about the questions I am asking: ${chatContext}`
                })
            });
    
            if (res.status === 200) {
                const data = await res.json();
                console.log('set chatbot context: ' + JSON.stringify(data));    
            } 
            else if (res.status === 413) {
                setAlertError ({
                    title: 'Chat Error: '
                    , body: 'Initial token count exceeds token limit. Please refine your request.'
                })
                setTimeout(() => {setAlertError(null)}, 5000);
                console.error('Chat error: ', 'token limit exceeded');
                resetChat();
            }
            else {
                const body = await errorMessage(res);
                setAlertError({ title: 'Chat Error: ', body });
                setTimeout(() => {setAlertError(null)}, 5000);
                console.error('Chat error: ', body);
                resetChat();
            }
        }

        if (chatContext) {
            do_post();
        } else {
            console.log('no context defined');
        }

    }, [resetChat, handleAPIRequest, chatContext]);

    useEffect(() => {
        setChatContext();
    }, [setChatContext, resetChat, handleAPIRequest, chatContext]);
 
 
    const onClickSendChat = async () => {

        setChatMessage('');
        setChatMessageSending(true);

        const res = await handleAPIRequest('/api/v1/chatbot', {
            method: 'POST',
            body: JSON.stringify({ 
                chatbot_input: chatMessage
            })
        });

        setChatMessageSending(false);

        if (res.status === 200) {
            const data = await res.json();
            console.log('received chat message: ' + JSON.stringify(data));
            setChatHistory((prevState) => [...prevState, data]);
        } 
        else if (res.status === 413) {
            setAlertError ({
                title: 'Chat Error: '
                , body: 'Initial token count exceeds token limit. Please refine your request.'
            })
            setTimeout(() => {setAlertError(null)}, 5000);
            console.error('Chat error: ', 'token limit exceeded');
            resetChat();
        }
        else {
			const body = await errorMessage(res);
			setAlertError({ title: 'Chat Error: ', body });
			setTimeout(() => {setAlertError(null)}, 5000);
			console.error('Chat error: ', body);
			resetChat();
		}
    }

    const onKeyDownChat = (event) => {
        if (event.key === 'Enter') {
            onClickSendChat();
        }
      };

    return (
        <>
            <Alert show={!!alertError} variant="danger">
                <Alert.Heading>{alertError ? alertError.title : ''}</Alert.Heading>
                <p>{alertError ? alertError.body : ''}</p>
            </Alert>

            <Container>
            <Row>
                { chatHistory.map((h, h_idx) => (
                    <div key={ `chatbot_${h_idx}` }>
                    <Row id={ `chatbot_input_${h_idx}` } className='mt-3'><b>{ username }</b> { h['chatbot_input'] }</Row>
                    <Row id={ `chatbot_output_${h_idx}` } className='mt-3' style={{'whiteSpace' : 'pre-wrap'}}><b>HealthRate</b> { h['chatbot_output'] }</Row>
                    <hr />
                    </div>
                ))}
            </Row>
            <Row className={ `mt-3 mb-3 mx-auto ${chatMessageSending ? '' : 'd-none' }` }><Spinner /></Row>
            </Container>
            <Row>
                <div className="input-group">
                    <span className="input-group-text">Chat</span>
                    <input type="text" className="form-control" value={ chatMessage } onChange={ (e) => setChatMessage(e.target.value) } id={ element_id + '_textFilter' } onKeyDown={ onKeyDownChat } autoComplete="off" />
                    <button id="chatbot_send_button" className="btn btn-primary" onClick={ onClickSendChat }>Send</button>
                </div>
            </Row>
        </>
    );

}
